import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Office File Graph Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.454 21.748a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-19.5A1.5 1.5 0 0 1 3 .748h15a1.5 1.5 0 0 1 1.047.426L22 4.057a1.5 1.5 0 0 1 .452 1.074z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.204 9.748a5.25 5.25 0 1 0 10.5 0 5.25 5.25 0 0 0-10.5 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.205 9.748h5.23l1.146 5.129M10.435 9.748l3.732-3.712M18.704 16.498h-3M18.704 19.498h-6.75"
    }, null, -1)
  ])))
}
export default { render: render }